<div
  class="tab-container"
  (mouseenter)="onHover(true)"
  (mouseleave)="onHover(false)">
  @if (hasUnreadMessages) {
    <div
      class="unread-messages-indicator"
      >
      <tidy-image [src]="'assets/img/email-white.png'" />
    </div>
  }
  <div class="tab-header" (click)="onToggle()">
    <div class="tab-header-left">
      <tidy-image [src]="icon" class="tab-icon-left" />
      <tidy-text [body]="title" />
    </div>
    @if (!isOpen) {
      <ion-icon
        name="chevron-down-outline"
        class="tab-icon"
      />
    }
    @if (isOpen) {
      <ion-icon
        name="chevron-up-outline"
        class="tab-icon"
      />
    }
  </div>
  <div class="tab-content" [@openClose]="isOpen ? 'open' : 'closed'">
    <ng-container *ngTemplateOutlet="content" />
  </div>
</div>
